import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Params } from '@angular/router';
import { ResultsState } from '../../models/state/results-state.interface';
import { HotelPricingSummary } from '@rx-applications/clientsite/shared/utils';

const reservationSelector = createFeatureSelector('Reservation');
export const resultsSelector = createSelector(reservationSelector, (state) => state['locationSearch'].results);

export const selectResults = createSelector(resultsSelector, ({ results }) => results);

export const selectMinMaxPrice = createSelector(resultsSelector, ({ results }) => {
  const combined = results.recommended
    .concat(results.other)
    .concat(results.nearby)
    .map((c) => c.price);

  return [Math.floor(Math.min(...combined)), Math.ceil(Math.max(...combined))];
});

export const selectPrices = createSelector(resultsSelector, ({ results }) => {
  return results.recommended
    .flatMap((result: HotelPricingSummary) => result.price)
    .concat(results.other.map((result: HotelPricingSummary) => result.price))
    .concat(results.nearby.map((result: HotelPricingSummary) => result.price)) as number[];
});

export const selectLocationName = createSelector(resultsSelector, (state: ResultsState) => {
  if (!!state.locations.length && !!state.locations[0]) {
    return state.locations[0].longLocationName;
  }
  return '';
});

export const selectSearchParams = createSelector(reservationSelector, ({ search }) => <Params>search.query);
